import { motion } from "framer-motion";

/**
 * Kinetic line-by-line masked reveal. Each line becomes a mask.
 * Props: lines (string[]), className, delay, wordStagger
 */
export default function RevealText({
  lines = [],
  className = "",
  delay = 0,
  as: Tag = "h1",
  duration = 0.9,
}) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask block">
          <motion.span
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{
              delay: delay + i * 0.12,
              duration,
              ease: [0.22, 1, 0.36, 1],
            }}
            className="block"
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

/**
 * Reveal a single string in a mask on scroll-in.
 */
export function RevealLine({ children, className = "", delay = 0 }) {
  return (
    <span className={`reveal-mask ${className}`}>
      <motion.span
        initial={{ y: "115%" }}
        whileInView={{ y: "0%" }}
        viewport={{ once: true, margin: "-10% 0px" }}
        transition={{ delay, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="block"
      >
        {children}
      </motion.span>
    </span>
  );
}
